import React, {useEffect, useRef} from "react";
import {ToastContainer} from "react-toastify";

import type IsaacNotificationsProps from "./IsaacNotificationsProps";
import useSignalRMessages from "../../services/signalR/hooks/useSignalRMessages";
import useMessageHandle from "./hooks/useMessageHandle";

const IsaacNotifications: React.FunctionComponent<IsaacNotificationsProps> = ({
  userName,
}) => {
  const messages = useSignalRMessages();
  const handleMessage = useMessageHandle();
  const processedMessageIdsRef = useRef(new Set<string>());

  useEffect(() => {
    if (messages === undefined || messages.length === 0) return;

    const unprocessed = messages.filter(
      m =>
        m.user !== undefined &&
        m.user === userName &&
        !m.isRead &&
        !processedMessageIdsRef.current.has(m.id),
    );

    if (unprocessed.length === 0) return;

    unprocessed.forEach(message => {
      processedMessageIdsRef.current.add(message.id);
      handleMessage(message);
    });
  }, [handleMessage, messages, userName]);

  return <ToastContainer stacked />;
};

export default IsaacNotifications;
